import { hideOnClickOutside } from '../utils/utils'

export default class TabsDropdown {
	constructor(el) {

		// TURNING THIS INTO AN ARRAY ENABLES US TO INDEX THROUGH IT
		this.dropdown		= el
		this.trigger		= el.querySelector('.tabs__select')
		this.options		= el.querySelectorAll('.tab')
		this.toggleDropdown	= this.toggleDropdown.bind(this)
		this.selectOption 	= this.selectOption.bind(this)

	}
  
	init() {
		
		// LISTEN FOR CLICKS ON EACH TAB ELEMENT
		if(this.trigger) {
			this.trigger.addEventListener('click', this.toggleDropdown )
		}

		// LISTEN FOR CLICKS ON EACH TAB OPTION
		if(this.options) {
			for (const option of this.options) {
				option.addEventListener( "click", this.selectOption )
			}
		}

	}

	toggleDropdown() {

		var otherOpenTabs = document.querySelectorAll('.tabs--open')
		this.closeOtherTabs(this.dropdown,otherOpenTabs)

		if( this.dropdown.classList.contains('tabs--open') ){

			this.dropdown.classList.remove('tabs--open')

		} else {
			// TOGGLE CURRENT NO MATTER WHAT
			this.dropdown.classList.add('tabs--open')
		}

		hideOnClickOutside( this.dropdown, null, 'tabs--open' )

	}

	closeOtherTabs(exceptThis,siblings) {
		for (var i = 0; i < siblings.length; i++) {
			if (siblings[i] !== exceptThis) {
				siblings[i].classList.remove("tabs--open");
			}
		}
	}

	selectOption(event) {

		//console.log('selectOptionfunction')

		this.options.forEach((option) => {
			option.classList.remove('tab--active')
		})

		event.target.classList.add('tab--active')

		// READY FOR API STUFF
		// var url = event.target.dataset.value;
		// window.location.href = url;

	}

}